<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>
        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="3">
                <CInput
                  label="Title"
                  invalid-feedback="Title should be filled"
                  required
                  v-model="$v.promotionForm.title.$model"
                  :is-valid="!$v.promotionForm.title.$invalid"
                  :readonly="isReadonly"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  label="Ordering"
                  invalid-feedback="Ordering should be filled"
                  required
                  v-model="$v.promotionForm.ordering.$model"
                  :is-valid="!$v.promotionForm.ordering.$invalid"
                  :readonly="isReadonly"
                />
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="status">Status</label>
                  <model-select
                    class="form-control"
                    id="status"
                    :options="statusList"
                    v-model="$v.promotionForm.status.$model"
                    :isError="$v.promotionForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.promotionForm.status.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Status should be filled.
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="flag">Redirect</label>
                  <model-select
                    class="form-control"
                    id="flag"
                    :options="redirectList"
                    v-model="$v.promotionForm.flag.$model"
                    :isError="$v.promotionForm.flag.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    :isDisabled="isReadonly"
                  ></model-select>
                  <div
                    v-if="$v.promotionForm.flag.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Redirect should be filled.
                  </div>
                </div>
              </CCol>
            </CRow>
            <br>
            <CRow>
              <CCol sm="3">
                <div class="form-group">
                  <label for="view_on_web">View On Web</label>
                  <model-select
                    class="form-control"
                    id="view_on_web"
                    :options="redirectList"
                    v-model="$v.promotionForm.view_on_web.$model"
                    :isError="$v.promotionForm.view_on_web.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    :isDisabled="isReadonly"
                  ></model-select>
                  <div
                    v-if="$v.promotionForm.view_on_web.$invalid"
                    class="invalid-feedback-custom"
                  >
                    View on web should be filled.
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="view_on_apps">View On Apps</label>
                  <model-select
                    class="form-control"
                    id="view_on_apps"
                    :options="redirectList"
                    v-model="$v.promotionForm.view_on_apps.$model"
                    :isError="$v.promotionForm.view_on_apps.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    :isDisabled="isReadonly"
                  ></model-select>
                  <div
                    v-if="$v.promotionForm.view_on_apps.$invalid"
                    class="invalid-feedback-custom"
                  >
                    View on apps should be filled.
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="view_on_voucher_page">View On Voucher Page</label>
                  <model-select
                    class="form-control"
                    id="view_on_voucher_page"
                    :options="redirectList"
                    v-model="$v.promotionForm.view_on_voucher_page.$model"
                    :isError="$v.promotionForm.view_on_voucher_page.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    :isDisabled="isReadonly"
                  ></model-select>
                  <div
                    v-if="$v.promotionForm.view_on_voucher_page.$invalid"
                    class="invalid-feedback-custom"
                  >
                    View on voucher page should be filled.
                  </div>
                </div>
              </CCol>
            </CRow>
            <br>
            <CRow>
              <CCol sm="9">
                <label for="nik">Description</label>
                <quill-editor
                  style="height: 200px; margin-bottom: 70px"
                  :content="content"
                  :options="editorOption"
                  v-model="$v.promotionForm.description.$model"
                  @change="onEditorChange($event)"
                  :disabled="isReadonly"
                >
                </quill-editor>
                <br />
                <div
                  v-if="$v.promotionForm.description.$invalid"
                  class="invalid-feedback-custom"
                >
                  Description harus di isi.
                </div>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              :disabled="$v.promotionForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Images</template>
            <UploadImage
              :promotion="promotionForm"
              :promotion-status="statusPromotion"
            ></UploadImage>
          </CTab>
          <CTab>
            <template slot="title">Images On Page</template>
            <UploadImageOnPage
              :promotion="promotionForm"
              :promotion-status="statusPromotion"
            ></UploadImageOnPage>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import UploadImage from "./tabs/UploadImage";
import UploadImageOnPage from "./tabs/UploadImageOnPage";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "PromotionDetail",
  components: { GlobalTable, Loading, UploadImage, quillEditor, UploadImageOnPage },
  data() {
    return {
      title: "Promotion Detail",
      promotionForm: tableInterfaces.promotion,
      isLoading: false,
      activeTab: 0,
      statusPromotion: null,
      voucherTypeList: [
        { value: "1", text: "Diskon Harga" },
        { value: "2", text: "Diskon Persen" },
      ],
      statusList: [
        { value: "1", text: "Active" },
        { value: "2", text: "Disabled" },
      ],
      redirectList: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" },
      ],
      content: "",
      editorOption: {}, // data quill
    };
  },
  validations: {
    promotionForm: {
      title: { required },
      ordering: { required },
      status: { required },
      flag: { required },
      view_on_apps: { required },
      view_on_web: { required },
      view_on_voucher_page: { required },
      description: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isReadonly: function () {
      return this.statusPromotion === "1" ? true : false;
    },
  },
  methods: {
    init: function (id) {
      this.getPromotionDetail(id);
    },
    getPromotionDetail: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/promotion/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.promotionForm = response.data.data;
            this.statusPromotion = this.promotionForm.status;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.promotion) {
        tableInterfaces.promotion[i] = null;
      }
      this.promotionForm = tableInterfaces.promotion;
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah promotion ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/promotion/update", this.promotionForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah promotion detail",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah promotion detail error");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.promotionForm.description = html;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
